const actions = {
  requested: ['approve', 'reject'],
  approved: ['cancel'],
}

export default (status) => actions[status] || []
